export default __webpack_public_path__ + "static/media/Spring.b92bc716.jpg";